import { Grid, Paper, Typography } from '@mui/material';
import { Field } from 'react-final-form';

import { FORM, STRINGS } from '../../../constants';
import ActionButton from '../../../components/ActionButton';
import { isDamagedFlow, isMissingFlow, isNotArrivedFlow } from '../helpers';

const ClaimTypeSelect = () => (
  <Paper sx={{ p: 2, mb: 2, mt: 2 }}>
    <Typography variant='h3' sx={{ mb: 1 }}>
      {STRINGS.CHOOSE_ONE_OF_OPTIONS}
    </Typography>
    <Field name={FORM.HELP_FIELDS.ISSUE_TYPE.KEY}>
      {({ input }) => (
        <Grid container spacing={2} sx={{ mt: 1, alignItems: 'stretch' }}>
          <Grid
            container
            size={{
              md: 4,
              xs: 12,
            }}
          >
            <ActionButton
              selected={isDamagedFlow(input.value)}
              title={STRINGS.DAMAGED}
              bodyText={STRINGS.MY_PARCEL_DAMAGED}
              cardOnclick={() => {
                input.onChange(FORM.ISSUE_TYPES.DAMAGED);
              }}
              additionalInfo={false}
            />
          </Grid>
          <Grid
            container
            size={{
              md: 4,
              xs: 12,
            }}
          >
            <ActionButton
              selected={isNotArrivedFlow(input.value)}
              title={STRINGS.NOT_ARRIVED}
              bodyText={STRINGS.MY_PARCEL_NOT_ARRIVED}
              cardOnclick={() => {
                input.onChange(FORM.ISSUE_TYPES.NOT_ARRIVED);
              }}
              additionalInfo={false}
            />
          </Grid>
          <Grid
            container
            size={{
              md: 4,
              xs: 12,
            }}
          >
            <ActionButton
              selected={isMissingFlow(input.value)}
              title={STRINGS.MISSING_CONTENTS}
              bodyText={STRINGS.MY_PARCEL_HAS_CONTENTS_MISSING}
              cardOnclick={() => {
                input.onChange(FORM.ISSUE_TYPES.MISSING_CONTENTS);
              }}
              additionalInfo={false}
            />
          </Grid>
        </Grid>
      )}
    </Field>
  </Paper>
);

export default ClaimTypeSelect;
